import app from "nystem";
import { ContentTypeRender, Wrapper, useLanguage } from "nystem-components";

const ViewButtonSetLanguage = ({ model, view, path }) => {
  const lang = useLanguage();
  const { _id, name } = view.value;

  return (
    <Wrapper
      renderAs="button"
      type="button"
      aria-label={name}
      aria-pressed={lang === _id}
      className={[model.className, lang === _id && model.activeClassName]}
      onClick={() =>
        model.navigate
          ? window.history.pushState({}, "", _id === app.settings.defaultLanguage ? "/" : `/${_id}`)
          : app.storage.setItem({ id: "language", value: _id })
      }
    >
      <ContentTypeRender path={path} items={model.item} />
    </Wrapper>
  );
};

export default ViewButtonSetLanguage;
